import { authApi } from "@/api/authApi";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import { useCookieTracking } from "./useCookieTracking";

export function useSocialAuthResolver() {
  const authStore = useAuthenticationStore();
  const { getTrackingCookies } = useCookieTracking();
  const checkForAuthCallback = async (route: RouteLocationNormalizedLoaded<string | symbol>) => {
    if (route.query.auth_callback) {
      const provider = route.query.auth_callback as string;
      if (provider && route.query?.code) {
        try {
          const queryString = window.location.search;
          const trackingCookies = getTrackingCookies();
          trackingCookies.client_ip = authStore.userIp;
          const response = await authApi.socialCallback(provider, queryString, {cookies: trackingCookies});
          if (response !== undefined && response.data.access_token && response.data.user) {
            authStore.login(response.data.user, response.data.access_token);
          }
        } catch (error) {
          console.error("Social auth callback failed:", error);
        }
      }
    }
  };

  return { checkForAuthCallback };
}
